// external dependencies
import React from 'react'
import { array, string } from 'prop-types'

// components
import { NearYou } from './NearYou'

// hooks
import { useScript } from '@jelly/utils'

InteractiveMap.propTypes = {
	guid: string.isRequired,
	services: array.isRequired,
}

export function InteractiveMap({ guid, services }) {
	const [loaded, error] = useScript(
		'https://maps.googleapis.com/maps/api/js?key=AIzaSyCw_OXsa0pC3ZB5SiEfxWEQMawa0TjL32w&libraries=places'
	)
	return <>{loaded && !error && <NearYou guid={guid} services={services} />}</>
}
